import { render } from "./homeView.vue?vue&type=template&id=379f144f&scoped=true"
import script from "./homeView.vue?vue&type=script&lang=js"
export * from "./homeView.vue?vue&type=script&lang=js"

import "./homeView.vue?vue&type=style&index=0&id=379f144f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\krist\\Documents\\pbetoon\\pBetoon-main\\ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-379f144f"]])

export default __exports__